import React from "react";
import { Redirect } from "react-router-dom";

// La raíz siempre manda al login (antes lo hacía con un history.push dentro del render).
function Home() {
  return <Redirect to="/login" />;
}

export default Home;
